<loading-layout #loadingLayout>
    <table-with-actions
        [contentArray]="generadores"
        [showParams]="params"
        [tableButtonsArray]="tableButtonsArray"
    ></table-with-actions>
    <paginator [getList]="this.showAll.bind(this)" *ngIf="plataforma"></paginator>
</loading-layout>
